import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { TRACKER_ENTITY_TYPE_BENCHMARK_ONE, TRACKER_ENTITY_TYPE_BENCHMARK_TWO, TRACKER_ENTITY_TYPE_BENCHMARK_THREE, TRACKER_ENTITY_TYPE_BENCHMARK_FOUR, TRACKER_ENTITY_TYPE_PRIMARY } from '../../constants/commons'

const styles = (theme) => ({
  root: {
    justifyContent: 'left'
  },
  scroller: {
    flexGrow: 0
  },
  tabButton: {
    fontFamily: 'Uni Sans Regular',
    textTransform: 'none',
    [theme.breakpoints.between('xs', 'md')]: {
      fontSize: '12px !important',
      minHeight: 'auto !important',
      padding: '5px !important'
    }
  }
})

class TrackerTabComponent extends React.Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    trackerPlan: PropTypes.object,
    setTrackerSelectedEntity: PropTypes.func.isRequired,
    fetchTrackerTeasersAndTrailers: PropTypes.func.isRequired,
    fetchWordCloud: PropTypes.func.isRequired,
    setSelectedTrackerEntityName: PropTypes.func.isRequired,
    setSelectedTrackerEntityDate: PropTypes.func.isRequired,
    selectedTrackerEntityType: PropTypes.string,
    selectedTrackers: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      trackerData: [],
      selectedEntity: ''
    }
  }

  componentDidMount () {
    if (this.props.selectedTrackers && this.props.selectedTrackers.length > 0) {
      const selectedEntity = this.props.selectedTrackers[0]
      this.setState({
        selectedEntity: selectedEntity && selectedEntity.name
      })
      this.handleSelect(selectedEntity.trackerEntityId, selectedEntity.lookbackDate, selectedEntity.name)
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedTrackers !== this.props.selectedTrackers && this.props.selectedTrackers && this.props.selectedTrackers.length > 0) {
      const selectedEntity = this.props.selectedTrackers[0]
      this.setState({
        selectedEntity: selectedEntity && selectedEntity.name
      })
      if (selectedEntity) {
        this.handleSelect(selectedEntity.trackerEntityId, selectedEntity.lookbackDate, selectedEntity.name, TRACKER_ENTITY_TYPE_PRIMARY)
      }
    }
  }

  handleSelect = (trackerEntityId, lookbackDate, name, trackerEntityType) => {
    const trackerId = this.props.trackerPlan.details && this.props.trackerPlan.details.tracker_topic.tracker_id
    this.props.setTrackerSelectedEntity(trackerId, trackerEntityId, trackerEntityType)
    this.props.fetchTrackerTeasersAndTrailers(trackerId, trackerEntityId)
    this.props.setSelectedTrackerEntityName(name)
    this.props.setSelectedTrackerEntityDate(lookbackDate)
  }

  render () {
    const { selectedTrackers, selectedTrackerEntityType } = this.props
    const primary = selectedTrackers && selectedTrackers[0]
    const defaultOne = selectedTrackers && selectedTrackers[1]
    const defaultTwo = selectedTrackers && selectedTrackers[2]
    const defaultThree = selectedTrackers && selectedTrackers[3]
    const defaultFour = selectedTrackers && selectedTrackers[4]
    return (
      <Box className="d-flex flex-wrap">
        { primary &&
          <Button variant="contained" className={selectedTrackerEntityType === TRACKER_ENTITY_TYPE_PRIMARY ? 'labelBtn primaryTrackerActive' : 'labelBtn'} onClick={() => this.handleSelect(primary.trackerEntityId, primary.lookbackDate, primary.name, TRACKER_ENTITY_TYPE_PRIMARY)}>{primary.name}</Button>
        }
        { defaultOne &&
          <Button variant="contained" className={selectedTrackerEntityType === TRACKER_ENTITY_TYPE_BENCHMARK_ONE ? 'labelBtn defaultOneTrackerActive' : 'labelBtn'} onClick={() => this.handleSelect(defaultOne.trackerEntityId, defaultOne.lookbackDate, defaultOne.name, TRACKER_ENTITY_TYPE_BENCHMARK_ONE)}>{defaultOne.name}</Button>
        }
        { defaultTwo &&
          <Button variant="contained" className={selectedTrackerEntityType === TRACKER_ENTITY_TYPE_BENCHMARK_TWO ? 'labelBtn defaultTwoTrackerActive' : 'labelBtn'} onClick={() => this.handleSelect(defaultTwo.trackerEntityId, defaultTwo.lookbackDate, defaultTwo.name, TRACKER_ENTITY_TYPE_BENCHMARK_TWO)}>{defaultTwo.name}</Button>
        }
        { defaultThree &&
          <Button variant="contained" className={selectedTrackerEntityType === TRACKER_ENTITY_TYPE_BENCHMARK_THREE ? 'labelBtn defaultThreeTrackerActive' : 'labelBtn'} onClick={() => this.handleSelect(defaultThree.trackerEntityId, defaultThree.lookbackDate, defaultThree.name, TRACKER_ENTITY_TYPE_BENCHMARK_THREE)}>{defaultThree.name}</Button>
        }
        { defaultFour &&
          <Button variant="contained" className={selectedTrackerEntityType === TRACKER_ENTITY_TYPE_BENCHMARK_FOUR ? 'labelBtn defaultFourTrackerActive' : 'labelBtn'} onClick={() => this.handleSelect(defaultFour.trackerEntityId, defaultFour.lookbackDate, defaultFour.name, TRACKER_ENTITY_TYPE_BENCHMARK_FOUR)}>{defaultFour.name}</Button>
        }
      </Box>
    )
  }
}

TrackerTabComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(TrackerTabComponent)
